import React from "react";
import { styled, TableRow, TableRowProps } from "@material-ui/core";
import { mix } from "polished";

export interface CustomTableRowProps extends TableRowProps {
  isStruck?: boolean;
  isGrey?: boolean;
  height?: string;
}

export const CustomTableRow = styled(
  ({ isStruck, isGrey, height, children, ...other }) => (
    <TableRow {...other}>{children}</TableRow>
  ),
)(({ isStruck, isGrey, height, theme }) => ({
  textDecoration: isStruck ? "line-through" : undefined,
  color: isGrey
    ? mix(0.7, theme.palette.text.primary, "#FFF")
    : theme.palette.text.primary,
  textDecorationColor:
    isStruck && isGrey
      ? mix(0.7, theme.palette.text.primary, "#FFF")
      : theme.palette.text.primary,
  height: height,
})) as React.FC<CustomTableRowProps>;
